import { Dropdown } from 'primereact/dropdown'
import CommonImage from '../CommonCompo/CommonImage/CommonImage'
import { Dialog } from 'primereact/dialog'
import { ProgressBar } from 'primereact/progressbar'

const UpdateTaskStatus = ({ options, popupValue, setPopupValue, updateReviewer }) => {
    return (
        <div>
            <Dialog draggable={false} visible={popupValue?.show} onHide={() => { setPopupValue({ show: false }) }} header="Code Review" className='modal-xsmall' modal resizable={false}>
                <div className='my-2'>
                    <label>Reviewer</label>
                    <Dropdown
                        options={options?.projectUsers}
                        className="sk-multiselect"
                        panelClassName="sk-multiselect-panel"
                        onChange={(e) => { setPopupValue((prev) => ({ ...prev, userCode: e.value })) }}
                        placeholder="Select Reviewer"
                        optionValue='user_code'
                        optionLabel='user_display_name'
                        value={popupValue?.userCode}
                    />
                </div>
                {
                    popupValue?.fileInput && <div className='my-2'>
                        <label>Files</label>
                        <CommonImage type="upload" selectedImages={popupValue?.file} setSelectedImages={(e) => setPopupValue((prev) => ({ ...prev, file: e }))} is_paste={false} />
                    </div>
                }
                {
                    popupValue?.uploadLoader && <div className="flex flex-column align-items-center p-4">
                        <ProgressBar mode="indeterminate" style={{ height: '6px', width: '100%' }} />
                        <p className="mt-2 text-sm text-gray-500">File is uploading; please do not close this window.</p>
                    </div>
                }

                <div className={`d-flex gap-2 justify-content-${popupValue?.fileInput ? "end" : "center"}`}>
                    <button className='sk-btn sk-btn-primary' onClick={() => setPopupValue({ show: false, file: [] })}>Cancel</button>
                    {popupValue?.loader ? <button className={`d-flex justify-content-center sk-btn bg-black text-white sk-btn-primary`} style={{ width: '15%', height: "50%" }}> <div class="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                        <span class="sr-only"></span>
                    </div></button> : <button className='sk-btn bg-black text-white sk-btn-primary' onClick={updateReviewer}>Save</button>}

                </div>
            </Dialog>
        </div>
    )
}

export default UpdateTaskStatus
